import { useIntl } from "react-intl";
import StatsWidget from "@rio-cloud/rio-uikit/StatsWidget";
import StatsWidgetNumber from "@rio-cloud/rio-uikit/StatsWidgetNumber";
import StatsWidgetSpacer from "@rio-cloud/rio-uikit/StatsWidgetSpacer";

interface ISchedulingCountsProps {
    preventiveCount: number;
    correctiveCount: number;
}

const SchedulingCounts = ({ preventiveCount, correctiveCount }: ISchedulingCountsProps) => {
    const intl = useIntl();
    return (
        <StatsWidget>
            <StatsWidget.Header>{intl.formatMessage({ id: "intl-msg:dealership.schedulingCounts.title" })}</StatsWidget.Header>
            <StatsWidget.Body>
                <StatsWidgetNumber
                    className="text-color-status-driving"
                    value={preventiveCount}
                    label={intl.formatMessage({ id: "intl-msg:appointment.step1.preventive" })}
                />
                <StatsWidgetSpacer />
                <StatsWidgetNumber
                    className="text-color-danger"
                    value={correctiveCount}
                    label={intl.formatMessage({ id: "intl-msg:appointment.step1.corrective" })}
                />
            </StatsWidget.Body>
        </StatsWidget>
    )
}

export default SchedulingCounts;